import { Upload } from "antd";
import styled from "styled-components";

export const StyledFileUpload = styled(Upload)`
    .ant-upload {
        width: 100%;
    }
`